/**
 * Component displays the dropdown component with predefined (onstants) values
 *
 */

import React, { useState, useEffect, FormEvent } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@fluentui/react';
import produce from 'immer';

import { appStyles } from '../../helpers';

type Props = {
    title?: string;
    selectedValue?: string | number | null;
    onChanged?: (value: string, settingsItem: unknown) => void;
    width?: number;
    disabled?: boolean;
    settingsItem?: unknown;
};

const TextFieldWrapper = (props: Props) => {
    const [state, setState] = useState<{ selectedValue: string | null }>({
        selectedValue: null,
    });

    useEffect(() => {
        setState(
            produce((draft) => {
                draft.selectedValue =
                    props.selectedValue == null
                        ? ''
                        : String(props.selectedValue);
            }),
        );
    }, [props]);

    const onChange = (
        _event: FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string,
    ): void => {
        setState(
            produce((draft) => {
                draft.selectedValue = newValue ?? '';
            }),
        );
        if (props.onChanged !== null && props.onChanged !== undefined) {
            props.onChanged(newValue ?? '', props.settingsItem);
        }
    };

    return (
        <TextField
            styles={appStyles.textBoxStyle}
            label={props.title}
            value={state.selectedValue ?? undefined}
            disabled={props.disabled}
            onChange={onChange}
        />
    );
};

export default TextFieldWrapper;

TextFieldWrapper.propTypes = {
    title: PropTypes.string,
    selectedValue: PropTypes.any,
    onChanged: PropTypes.func,
    width: PropTypes.number,
    disabled: PropTypes.bool,
    settingsItem: PropTypes.any,
};
